var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"pc-banner"},[_c('img',{attrs:{"src":require("../assets/pc/pc-banner.png"),"alt":"重庆市大学生创意传播作品大赛"}}),_c('button',{staticClass:"entry-btn",attrs:{"type":"button"},on:{"click":_vm.goSignup}},[_c('img',{attrs:{"src":require("../assets/pc/btn.png"),"alt":"立即报名"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }